<template>
  <transition name="slide-fade">
    <div 
      v-if="visible" 
      class="toast-notification" 
      :class="'toast-' + type"
    >
      <div class="toast-content">
        <span class="toast-icon">
          <font-awesome-icon v-if="type === 'success'" icon="check-circle" />
          <font-awesome-icon v-if="type === 'error'" icon="exclamation-circle" />
          <font-awesome-icon v-if="type === 'warning'" icon="exclamation-triangle" />
          <font-awesome-icon v-if="type === 'info'" icon="info-circle" />
        </span>
        <span class="toast-message">{{ message }}</span>
        <button class="toast-close" @click="close">×</button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ToastNotification",
  props: {
    message: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: "info",
      validator: (value) => ["success", "error", "warning", "info"].includes(value),
    },
    duration: {
      type: Number,
      default: 3000,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
      timer: null,
    };
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.showToast();
      }
    },
  },
  methods: {
    showToast() {
      this.visible = true;
      this.clearTimer();
      
      if (this.duration > 0) {
        this.timer = setTimeout(() => {
          this.close();
        }, this.duration);
      }
    },
    close() {
      this.visible = false;
      this.clearTimer();
      this.$emit("close");
    },
    clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
  },
  mounted() {
    if (this.show) {
      this.showToast();
    }
  },
  beforeDestroy() {
    this.clearTimer();
  },
};
</script>

<style lang="scss" scoped>
.toast-notification {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 99999;
  min-width: 300px;
  max-width: 500px;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  
  &.toast-success {
    background-color: #28a745;
    color: white;
  }
  
  &.toast-error {
    background-color: #dc3545;
    color: white;
  }
  
  &.toast-warning {
    background-color: #ffc107;
    color: #212529;
  }
  
  &.toast-info {
    background-color: #17a2b8;
    color: white;
  }
}

.toast-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.toast-icon {
  font-size: 20px;
  flex-shrink: 0;
}

.toast-message {
  flex: 1;
  font-size: 14px;
  font-weight: 500;
  word-break: break-word;
}

.toast-close {
  background: transparent;
  border: none;
  color: inherit;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  line-height: 1;
  flex-shrink: 0;
  opacity: 0.8;
  transition: opacity 0.2s;
  
  &:hover {
    opacity: 1;
  }
}

// Slide fade transition
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.2s ease-in;
}

.slide-fade-enter {
  transform: translateX(100%);
  opacity: 0;
}

.slide-fade-leave-to {
  transform: translateX(100%);
  opacity: 0;
}
</style>